// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GameScreen_container__L0DIp {
  max-width: 600px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  padding: 16px;
  gap: 32px;
  min-height: 100vh;
  justify-content: space-between;
}

.GameScreen_stack0__ygnm9 {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.GameScreen_stack8__tAI13 {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.GameScreen_stack16__vF03u {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.GameScreen_small__jd-Xz {
  font-size: var(--font-size-24);
}

.GameScreen_greySmall__1csM- {
  color: #757575;
  font-size: var(--font-size-24);
}

.GameScreen_animateFromTop__sG5ki {
  transform: translateY(-8px);
  opacity: 0;
  transition: transform 0.2s ease-in-out, opacity 0.2s ease-in-out;
}

.GameScreen_animateFromTopIn__gGATi {
  transform: translateY(0);
  opacity: 1;
}

@media (prefers-reduced-motion: reduce) {
  .GameScreen_animateFromTop__sG5ki {
    transition: none;
  }
}

.GameScreen_animateFromBottom__t4d5I {
  transform: translateY(8px);
  opacity: 0;
  transition: transform 0.2s ease-in-out, opacity 0.2s ease-in-out;
}

.GameScreen_animateFromBottomIn__IL9v3 {
  transform: translateY(0);
  opacity: 1;
}

@media (prefers-reduced-motion: reduce) {
  .GameScreen_animateFromTop__sG5ki {
    transition: none;
  }
}

.GameScreen_thumbButtons__iespC {
  display: flex;
  justify-content: space-between;
}

.GameScreen_thumbButton__tT8N- {
  font-size: var(--font-size-24);
  color: #757575;
}

.GameScreen_thumbButton__tT8N- svg:first-child {
  margin-right: 8px;
}

.GameScreen_thumbButton__tT8N- svg:last-child {
  margin-left: 8px;
}

.GameScreen_thumbButtonRed__0l45X {
  color: #dc4632;
}

.GameScreen_thumbButtonRed__0l45X svg path {
  fill: currentColor;
}

.GameScreen_thumbButtonGreen__BtAgD {
  color: #32dc51;
}

.GameScreen_thumbButtonGreen__BtAgD svg path {
  fill: currentColor;
}
`, "",{"version":3,"sources":["webpack://./src/GameScreen.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,UAAU;EACV,gEAAgE;AAClE;;AAEA;EACE,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,0BAA0B;EAC1B,UAAU;EACV,gEAAgE;AAClE;;AAEA;EACE,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".container {\n  max-width: 600px;\n  display: flex;\n  flex-direction: column;\n  margin: 0 auto;\n  padding: 16px;\n  gap: 32px;\n  min-height: 100vh;\n  justify-content: space-between;\n}\n\n.stack0 {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.stack8 {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.stack16 {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.small {\n  font-size: var(--font-size-24);\n}\n\n.greySmall {\n  color: #757575;\n  font-size: var(--font-size-24);\n}\n\n.animateFromTop {\n  transform: translateY(-8px);\n  opacity: 0;\n  transition: transform 0.2s ease-in-out, opacity 0.2s ease-in-out;\n}\n\n.animateFromTopIn {\n  transform: translateY(0);\n  opacity: 1;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .animateFromTop {\n    transition: none;\n  }\n}\n\n.animateFromBottom {\n  transform: translateY(8px);\n  opacity: 0;\n  transition: transform 0.2s ease-in-out, opacity 0.2s ease-in-out;\n}\n\n.animateFromBottomIn {\n  transform: translateY(0);\n  opacity: 1;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .animateFromTop {\n    transition: none;\n  }\n}\n\n.thumbButtons {\n  display: flex;\n  justify-content: space-between;\n}\n\n.thumbButton {\n  font-size: var(--font-size-24);\n  color: #757575;\n}\n\n.thumbButton svg:first-child {\n  margin-right: 8px;\n}\n\n.thumbButton svg:last-child {\n  margin-left: 8px;\n}\n\n.thumbButtonRed {\n  color: #dc4632;\n}\n\n.thumbButtonRed svg path {\n  fill: currentColor;\n}\n\n.thumbButtonGreen {\n  color: #32dc51;\n}\n\n.thumbButtonGreen svg path {\n  fill: currentColor;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `GameScreen_container__L0DIp`,
	"stack0": `GameScreen_stack0__ygnm9`,
	"stack8": `GameScreen_stack8__tAI13`,
	"stack16": `GameScreen_stack16__vF03u`,
	"small": `GameScreen_small__jd-Xz`,
	"greySmall": `GameScreen_greySmall__1csM-`,
	"animateFromTop": `GameScreen_animateFromTop__sG5ki`,
	"animateFromTopIn": `GameScreen_animateFromTopIn__gGATi`,
	"animateFromBottom": `GameScreen_animateFromBottom__t4d5I`,
	"animateFromBottomIn": `GameScreen_animateFromBottomIn__IL9v3`,
	"thumbButtons": `GameScreen_thumbButtons__iespC`,
	"thumbButton": `GameScreen_thumbButton__tT8N-`,
	"thumbButtonRed": `GameScreen_thumbButtonRed__0l45X`,
	"thumbButtonGreen": `GameScreen_thumbButtonGreen__BtAgD`
};
export default ___CSS_LOADER_EXPORT___;
